module.exports = __webpack_public_path__ + "static/media/cofre100.056212ff.png";